import { QUESTION_TYPE, QUESTION_TYPE_LABEL } from '@/consts/survey';

export default {
  /**
   * All data that need to be changed before go to view
   */
  getMetrics: (state, getters) => (questionsParam, allowMetrics, chart) => {
    const allSurveys = state.surveys;
    const surveyListPermitted = getters.getsurveyListPermitted(chart);
    const metrics = [];
    let questions = [];
    if (!surveyListPermitted.length) {
      const items = allSurveys?.map((survey) => survey.items) || [];
      items?.forEach((item) => {
        item?.forEach((question) => {
          questions = questions.concat(question);
        });
      });
    } else {
      questions = questionsParam;
    }
    questions?.forEach((question) => {
      if (!question) {
        return;
      }
      if (question.type === QUESTION_TYPE.LABEL || question.type === QUESTION_TYPE.IMAGE) {
        return;
      }
      if (allowMetrics && !allowMetrics.includes(question.type)) {
        // If this kind of chart dont allow any metric, check if question type is part of this metric
        return;
      }
      const found = metrics.find((metric) => metric.id === question.type);
      if (!found) {
        metrics.push({
          id: question.type,
          checked: !question.hide,
          name: QUESTION_TYPE_LABEL[question.type],
        });
      }
    });
    return metrics;
  },
  getsurveyOptions: (state) => (chartIn) => {
    const chart = chartIn;
    const allSurveys = state?.surveys;
    // For all surveys, detect if is in surveys selected array
    let options = [
      {
        uuid: 'all',
        name: 'dashboard.settings.all_surveys',
        items: null,
      },
    ];

    if (!allSurveys) {
      return options;
    }

    if (!chart.settings.metrics) chart.settings.metrics = [];

    allSurveys?.forEach((survey) => {
      const hasSelectedMetric = survey.items?.some((i) => chart.settings.metrics.includes(i.type));
      // If don't have survey selected, add in select box
      if (hasSelectedMetric) {
        options = options.concat({
          uuid: survey.uuid,
          name: survey.name,
          items: survey.items,
        });
      }
    });

    const [allSurveysOption] = options;
    if (allSurveysOption.uuid === 'all' && options.length === 1) {
      return [...options, ...allSurveys];
    }

    return options;
  },
  getsurveyListPermitted: (state) => (chart) => {
    const allSurveys = state.surveys;
    return chart.settings.surveys.filter((survey) => {
      const found = allSurveys?.find((surveyPermitted) => surveyPermitted.uuid === survey.uuid);
      if (found) {
        return true;
      }
      return false;
    });
  },
  selectedSurveyItem: (state) => {
    if (state.selectedSurveyItemIndex !== null && state.selectedSurveyItemIndex !== undefined) {
      return state.survey.items[state.selectedSurveyItemIndex];
    }
    return null;
  },
  getSurveyUserTeamsIds: (state, getters, rootState, rootGetters) => {
    const listTeams = [];
    state.teamsPermission.forEach((team) => listTeams.push(team));
    return listTeams;
  },
};
